/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useState } from "react";
import { Button, Col, Form, List, Modal, Row, Tooltip, message, Input, Avatar, Card, Spin, Typography } from "antd";
import { SearchOutlined, UserOutlined, DeleteTwoTone, ExclamationCircleOutlined, PlusCircleFilled, PlusOutlined, EditOutlined } from "@ant-design/icons";
import { ClientList } from "./ClientList";
import { EmptyData } from "../../Common/components/EmptyData";
import { useMediaQuery } from "react-responsive";
import AddClient from "./AddClient";
// import buildSignatureBlocks from "../features/helpers/buildSignatureBlocks";
import styles from "../styles/CobuyerCosellerList.module.css";
import { v4 as uuidv4 } from "uuid";
import ManualAddSeller from "./ManualAddSeller";
import { extractUniqueClientIds, formatClientAddress, formatPhoneNumber, generateFullNameFromObj, generateInitialsFromObj } from "../../Common/utils/universalFuntions";
import EachCorpSigner from "./EachCorpSigner";
import { documentAction } from "../../DocumentSection/state/actions";
import { contractStoreHandle } from "../../ContractStore/state/actions";
import { checkOnlySignersAllowedToEdit, getInitiatingAgentDetails } from "../features/helperFunctions";
import axios from "axios";
import AddEmail from "../../Common/components/AddEmail";
import { transactionLaneDataHandle } from "../../Rtd/state/actions";
import { otherDocsContractTypes } from "../../Common/commondata/commonData";
import { contractDataHandle } from "../state/actions";
const { confirm } = Modal;

const EditCorpOrClient = ({ sourceType, clientType, contractAuthKey, currentUrlId, rootDocData, modalState, contractData, renderScreen }) => {
  const isMobile = useMediaQuery({ maxWidth: 480 });
  const dispatch = useDispatch();
  const [clientsArray, setClientsArray] = useState([]);
  const [currentlySelectedData, setCurrentlySelectedData] = useState([]);
  const [showClientListModal, setShowClientListModal] = useState(false);
  const [clientDetailModal, setClientDetailModal] = useState({
    visible: false,
    data: {},
  });
  const [addCorps, setAddCorp] = useState(false);
  const [trustName, setTrustName] = useState("");
  const [getClientData, setClientData] = useState([]);
  const [visible, setVisible] = useState(false);
  const onlySignersAllowedToEdit = checkOnlySignersAllowedToEdit(rootDocData);

  const { labelType, addAsSelf, clientAlphabetKey } = modalState || {};

  const [rootLevelEmailChanged, setRootLevelEmailChanged] = useState(false);
  const { allClientDetailsData, allClientDetailsLoading } = useSelector((state) => state.createOffer);

  useEffect(() => {
    if(renderScreen === "OFFER_IMPORT") return;
    let sourceAxios = axios.CancelToken.source();
    let unmounted = { value: false };
    let localData = JSON.parse(localStorage.getItem(currentUrlId)) || {};
    let clients = extractUniqueClientIds(localData[clientType]);
    const clientIds = [...new Set([...clients])];
    dispatch(contractDataHandle.getAllClientDetails({
      clientIds,
      accessToken: contractAuthKey,
      currentUrlId,
      source: 'EDIT_CLIENT_MODAL',
      sourceAxios,
      unmounted
    }));
    return () => {
      unmounted.value = true;
      sourceAxios.cancel("Component unmounted");
    }
  }, [])

  useEffect(() => {
    let localData = JSON.parse(localStorage.getItem(currentUrlId)) || {};
    let clients = localData[clientType];
      // console.log("clients", localData, clients, clientType);
    if (!Array.isArray(clients)) return;
    const filteredClients = labelType ? clients.filter((client) => client.labelType === labelType) : clients.filter((client) => !client.labelType);
    setClientsArray(filteredClients);
    setRootLevelEmailChanged(false);
  }, [clientType, labelType, rootLevelEmailChanged, allClientDetailsData]);
  // console.log("clientsArray", clientsArray);;
  const handleClientSelected = (selectedClient) => {
    let localData = JSON.parse(localStorage.getItem(currentUrlId)) || {};
    const clients = localData[clientType] || [];
    if (clientsArray.length >= 10) {
      message.error(`Maximum number of contacts already added.`);
      return;
    }
    if (currentlySelectedData?.isCorp && currentlySelectedData.signers.some((el) => el.personId === selectedClient._id)) {
      message.error(`Contact already exists in the signers list.`);
      return;
    } else if (!currentlySelectedData?.isCorp && clientsArray.some((client) => client.personId === selectedClient._id)) {
      message.error(`Contact already exists in the list.`);
      return;
    }
    if (otherDocsContractTypes.includes(rootDocData?.contractType)) {
      let corpArray = clientsArray.filter((el) => el.isCorp);
      if (!currentlySelectedData?.isCorp && clientsArray?.length >= 1) {
        message.error("You can only add one person — either individual or corporate.");
        return;
      }
      if (currentlySelectedData?.isCorp && corpArray[0]?.signers?.length >= 1) {
        message.error("Only one signer can be added for a corporation.");
        return;
      }
    }

    let clientInfo;
    const signerFields = clientType === "Buyers" ? contractData?.buyerFields || {} : contractData?.sellerFields || {};
    let additionalFields = {};
    if (signerFields.email || [...otherDocsContractTypes,"WY_RLC"].includes(rootDocData?.contractType)) {
      additionalFields = {
        faxNumber: formatPhoneNumber(selectedClient?.faxNumber),
        address: formatClientAddress(selectedClient?.addressObj),
        phoneNumber: formatPhoneNumber(selectedClient?.mobilePhoneNumber?.phoneNumber),
      };
    }
    if (currentlySelectedData?.isCorp) {
      clientInfo = { fullName: generateFullNameFromObj(selectedClient), personId: selectedClient._id, email: selectedClient.email, ...additionalFields };
    } else {
      clientInfo = { fullName: generateFullNameFromObj(selectedClient), personId: selectedClient._id, isCorp: false, signers: [], labelType: labelType || "", email: selectedClient.email, ...additionalFields };
    }
    if (currentlySelectedData?.isCorp) {
      let newDataIndex = clients.findIndex((el) => el.key === currentlySelectedData.key);
      if (newDataIndex !== -1) {
        localData[clientType] = [...clients.slice(0, newDataIndex), { ...clients[newDataIndex], signers: [...(clients[newDataIndex].signers || []), clientInfo] }, ...clients.slice(newDataIndex + 1)];
      }
    } else {
      localData[clientType] = [...clients, clientInfo];
    }
    handleDataChange({ updatedLocalData: localData, clientType });
  };

  const handleDelete = (element, type, item) => {
    let localData = JSON.parse(localStorage.getItem(currentUrlId)) || {};
    if (localData[clientType]) {
      if (sourceType === "NORMAL") {
        if (type === "CORP") {
          handleCorpDelete(element, item);
          return;
        } else if (type === "SIGNERS") {
          let newDataIndex = localData[clientType]?.findIndex((el) => el.key === element.key);
          if (newDataIndex !== -1) {
            localData[clientType][newDataIndex].signers = localData[clientType][newDataIndex]?.signers?.filter((signer) => signer.personId !== item?.personId);
          }
          // console.log("element.personId", element.personId);
          // console.log("newDataIndex", newDataIndex, localData[clientType][newDataIndex].signers);
        } else {
          localData[clientType] = localData[clientType]?.filter((el) => !(el.personId === element.personId && (labelType ? el.labelType === labelType : !el.labelType)));
        }
      } else {
        if (type === "CORP") {
          handleCorpDelete(element);
          return;
        } else if (type === "SIGNERS") {
          let newDataIndex = localData[clientType]?.findIndex((el) => el.key === element.key);
          // console.log(localData[clientType][newDataIndex].signers, "testing above one else");
          if (newDataIndex !== -1) {
            localData[clientType][newDataIndex].signers = localData[clientType][newDataIndex]?.signers?.filter((signer) => {
              if (item.key) {
                // console.log("signer.key:", signer.key);
                return signer.key !== item.key;
              } else {
                return signer.personId !== item.personId;
              }
            });
            // console.log(localData[clientType][newDataIndex].signers, "testing inside else");
          }
        } else {
          localData[clientType] = localData[clientType]?.filter((el) => {
            if (element.personId) {
              // console.log("el.personId:", el.personId);
              return !(el.personId === element.personId && (labelType ? el.labelType === labelType : !el.labelType));
            } else {
              // console.log("el.key:", el.key);
              return el.key !== element.key;
            }
          });
        }
      }
      let transactionObj={}
      if (["DC_RA", "DC_CAL"].includes(rootDocData?.contractType)) {
        const personDetails =  type === "SIGNERS" ? item : element;
        handleUpdateOtherInputs({updatedLocalData: localData, personDetails, transactionObj, actionType: "DELETE" });
      }
      handleDataChange({updatedLocalData: localData, clientType, transactionObj });
    }
  };

  const handleDataChange = ({ updatedLocalData = {}, clientType = "Buyers", transactionObj = {} }) => {
    const filteredClients = updatedLocalData[clientType]?.filter((client) => (labelType ? client.labelType === labelType : !client.labelType));
    setClientsArray(filteredClients || []);
    localStorage.setItem(currentUrlId, JSON.stringify(updatedLocalData));
    if (contractAuthKey) {
      dispatch(contractStoreHandle.autoSaveContract({ currentUrlId, contractAuthKey, valueObj: { [clientType]: updatedLocalData[clientType], ...(transactionObj && { ...transactionObj } ) } }));
    } else {
      dispatch(documentAction.setpdfImportState({ [clientType]: updatedLocalData[clientType] }));
    }
  };
  const handleCancel = () => {
    setShowClientListModal(false);
  };

  const handleCorpDelete = (element = {}) => {
    let localData = JSON.parse(localStorage.getItem(currentUrlId)) || {};
    confirm({
      title: `Are you sure you want to remove ${element.fullName} from this form?`,
      okText: "Yes",
      cancelText: "No",
      icon: <ExclamationCircleOutlined />,
      content: "Note: This will also remove all the signers associated with it.",
      onOk() {
        localData[clientType] = localData[clientType]?.filter((el) => el.key !== element.key);
        let transactionObj={}
        if (["DC_RA", "DC_CAL"].includes(rootDocData?.contractType)) {
          handleUpdateOtherInputs({updatedLocalData: localData, personDetails: element?.signers?.[0], transactionObj, actionType: "DELETE" });
        }
        handleDataChange({updatedLocalData:localData, clientType, transactionObj});
      },
      onCancel() {},
    });
  };
  const handleAddSigners = (element) => {
    setShowClientListModal(true);
    setCurrentlySelectedData(element);
    // setAddCorp(!addCorps);
  };

  const handleCorpAdd = () => {
    setTrustName("");
    let corpInfo = {
      fullName: trustName?.trim(),
      isCorp: true,
      key: uuidv4(),
      signers: [],
      labelType: labelType || "",
    };
    if (otherDocsContractTypes.includes(rootDocData?.contractType) && clientsArray?.length >= 1) {
      message.error("You can only add one person — either individual or corporate.");
      return;
    }
    let localData = JSON.parse(localStorage.getItem(currentUrlId)) || {};
    if (clientType) {
      localData[clientType] = [...(localData[clientType] || []), corpInfo];
    }
    handleDataChange({updatedLocalData: localData, clientType});
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleCorpAdd();
    }
  };
  const nonCorpClients = clientsArray.filter((ele) => !ele.isCorp);
  const corpClients = clientsArray?.filter((ele) => ele.isCorp) || [];

  const [enterEmailModal, setEnterEmailModal] = useState({
    visible: false,
    data: {},
    inValid: false,
  });

  const handleAvatarClick = ({ item, source }) => {
    return;
    // if (source !== "ROOT_LEVEL_ADD_EMAIL") {
    //   setClientDetailModal({ ...clientDetailModal, data: item, visible: true });
    // } else {
    //   setClientDetailModal({ ...clientDetailModal, data: item });
    //   setEnterEmailModal({ ...enterEmailModal, visible: true, data: item });
    // }
  };

  const [form] = Form.useForm();
  const callClientApi = clientDetailModal?.data?.personId ? true : false;
  const [fullName, setFullName] = useState("name");
  useEffect(() => {
    const name = clientDetailModal?.data?.personId?.fullName || clientDetailModal?.data?.fullName || "";
    setFullName(name);
  }, [clientDetailModal.data]);

  const handleAddEmail = (values, check) => {
    let data = {
      addToProperty: false,
      offerId: rootDocData?.offerId,
      ...(clientType === "Buyers" && rootDocData?.openFor === "BUYER_AGENT"
        ? {
            buyerDetail: {
              fullName,
              ...(clientDetailModal?.data?.personId
                ? {
                    personId: clientDetailModal?.data?.personId,
                  }
                : {
                    key: clientDetailModal?.data?.key ? clientDetailModal?.data?.key : clientDetailModal?.data?._id,
                    isCorp: clientDetailModal?.data?.isCorp,
                    corpKey: clientDetailModal?.data?.corpKey,
                  }),
              ...(values?.email?.length > 0 ? { email: values?.email?.toLowerCase() } : {}),
            },
            openFor: "BUYER_AGENT"
          }
        : {
            sellerDetail: {
              fullName,
              ...(clientDetailModal?.data?.personId
                ? {
                    personId: clientDetailModal?.data?.personId,
                  }
                : {
                    key: clientDetailModal?.data?.key ? clientDetailModal?.data?.key : clientDetailModal?.data?._id,
                    isCorp: clientDetailModal?.data?.isCorp,
                    corpKey: clientDetailModal?.data?.corpKey,
                  }),
              ...(values?.email?.length > 0 ? { email: values?.email?.toLowerCase() } : {}),
            },
            openFor: "SELLER_AGENT"
          }),
      ...(values?._id ? { selectedId: values?._id } : {}),
      ...(check ? { newClient: true } : {}),
    };
    setEnterEmailModal({ ...enterEmailModal, visible: false });

    let localData = JSON.parse(localStorage.getItem(currentUrlId)) || {};
    const clients = localData[clientType] || [];

    const updatedClients = clients.map((client) => {
      // If the current client matches the personId, update their email
      if (client.personId === clientDetailModal?.data?.personId) {
        return { ...client, email: values?.email?.toLowerCase() };
      }

      // If the client has signers, update the email inside the signers array
      if (client.signers && Array.isArray(client.signers)) {
        const updatedSigners = client.signers.map((signer) => (signer.personId === clientDetailModal?.data?.personId ? { ...signer, email: values?.email?.toLowerCase() } : signer));

        return { ...client, signers: updatedSigners };
      }

      return client;
    });

    // Update localData and save back to localStorage
    localData[clientType] = updatedClients;
    localStorage.setItem(currentUrlId, JSON.stringify(localData));
    dispatch(transactionLaneDataHandle.addEmailFun({ data, userAuthKey: contractAuthKey, source: callClientApi ? "AVATAR_DATA" : "AVATAR_PAGE_REFRESH", setEnterEmailModal, enterEmailModal, form, currentUrlId, clientType, localData, setRootLevelEmailChanged }));
  };

  const handleAddMe = () => {
    let localData = JSON.parse(localStorage.getItem(currentUrlId)) || {};
    let clients = localData[clientType] || [];
    let { officeDetails: { agentId } = {} } = localData || {};

    if (rootDocData.contractType.startsWith("WY_")) {
      const agentData = getInitiatingAgentDetails({ localData, rootDocData });
      if (!agentData || !Object.keys(agentData)?.length) return;
      if (localData[clientType]?.some((el) => el.personId === agentData.personId)) {
        message.error("You are already exists in the list.");
        return;
      }
      localData[clientType] = [...clients, { ...agentData, isCorp: false, labelType: labelType }];
      handleDataChange({ updatedLocalData: localData, clientType, transactionObj: {} });
      message.success("Added Successfully!");
      return;
    } else {
      let buyerAgent = (localData["BuyerAgents"] || []).filter((el) => el.personId === agentId);
      if (buyerAgent.length) {
        const corpArray = clientsArray.filter((el) => el.isCorp);
        if (corpArray.length && !corpArray[0]?.signers?.length) {
          let newDataIndex = clients.findIndex((el) => el.key === corpArray[0].key);
          if (newDataIndex !== -1) {
            localData[clientType] = [...clients.slice(0, newDataIndex), { ...clients[newDataIndex], signers: [...(clients[newDataIndex].signers || []), { ...buyerAgent[0] }] }, ...clients.slice(newDataIndex + 1)];
          }
        } else {
          localData[clientType] = [...clients, { ...buyerAgent[0], isCorp: false, labelType: labelType }];
        }
        let transactionObj = {};
        if (["DC_RA", "DC_CAL"].includes(rootDocData?.contractType)) {
          handleUpdateOtherInputs({ updatedLocalData: localData, personDetails: buyerAgent[0], transactionObj, actionType: "ADD" });
        }
        handleDataChange({ updatedLocalData: localData, clientType, transactionObj });
      }
      message.success("Added Successfully!");
      return;
    }
  };
  // to update the other related input fields when any clients are added or gets removed.
  const handleUpdateOtherInputs = ({  updatedLocalData, personDetails={}, actionType, transactionObj = {} }) => {
    try { 
      switch (rootDocData?.contractType) {
        case "DC_RA":
        case "DC_CAL":
          const associtedInputFields = contractData?.additionalClientInfo?.[clientAlphabetKey]?.default?.associtedInputFields || {};
          // console.log("associtedInputFields", associtedInputFields);
          Object.entries(associtedInputFields).forEach(([inputName, clientKey]) => {
            const allInputs = document.getElementsByName(inputName);
              // console.log("allInputs", allInputs);
            allInputs.forEach((inputEl) => {
              if (actionType === "DELETE") {
                inputEl.value = "";
                updatedLocalData[inputEl.name] = "";
                transactionObj[inputEl.name] = ""
                inputEl.parentNode.dataset.replicatedValue = ""
                // console.log("inputEl.parentNode.dataset.replicatedValue", inputEl.name, transactionObj);
              } else {
                const clientValue = personDetails[clientKey] || "";
                if (!updatedLocalData[inputEl.name] && clientValue) {
                  inputEl.value = clientValue;
                  updatedLocalData[inputEl.name] = clientValue;
                  transactionObj[inputEl.name] = clientValue;
                  inputEl.parentNode.dataset.replicatedValue = clientValue
                }
              }
            });
          });
          break;
        default:
          break;
      }
    } catch (error) {}
  };
  const corpArray = clientsArray?.filter((el) => el.isCorp);
  const checkIfAddMeBtnVisible = () => {
    if (!addAsSelf) return false;
    if (rootDocData?.contractType.startsWith("WY_")) {
        let localData = JSON.parse(localStorage.getItem(currentUrlId)) || {};
      const agentData = getInitiatingAgentDetails({ localData, rootDocData });
      if (!agentData || !Object.keys(agentData)?.length) return false;
      if (localData[clientType]?.some((el) => el.personId === agentData.personId)) {
        return false;
      }
      return true;
    }
    return !!(!clientsArray?.length || (corpArray?.length && !corpArray?.[0]?.signers?.length));
  }; 

  return (
    <>
      {showClientListModal ? (
        <Modal width={600} style={{ height: "600px" }} visible={showClientListModal} title={<div className="commonModalTitle">{sourceType === "MANUAL_ADD_CLIENTS" ? `Add Signers for ${currentlySelectedData.fullName}` : ""}</div>} onOk={handleCancel} mask={true} closable={true} onCancel={handleCancel} footer={null}>
          {sourceType === "MANUAL_ADD_CLIENTS" ? <ManualAddSeller currentUrlId={currentUrlId} contractAuthKey={contractAuthKey} sourceType={sourceType} source={"CORP"} currentlySelectedData={currentlySelectedData} clientType={clientType} clientsArray={clientsArray} setClientsArray={setClientsArray} handleCorpAdd={handleCorpAdd} trustName={trustName} setTrustName={setTrustName} setCurrentlySelectedData={setCurrentlySelectedData} labelType={labelType} /> : <ClientList onAdd={handleClientSelected} accessTokan={contractAuthKey} handleCancel={handleCancel} setShowClientListModal={setShowClientListModal} source={"Documents"} labelType={labelType} />}
        </Modal>
      ) : null}
      {visible ? <AddClient clientType={clientType} visible={visible} setVisible={setVisible} setClientData={setClientData} accessTokan={contractAuthKey} /> : null}

      {clientDetailModal?.visible && (
        <Modal visible={true} closable={true} onCancel={() => setClientDetailModal({ visible: false })} footer={null}>
          <ClientDetailSection contractAuthKey={contractAuthKey} clientDetailModal={clientDetailModal} clientType={clientType} currentUrlId={currentUrlId} clientsArray={clientsArray} isMobile={isMobile} enterEmailModal={enterEmailModal} setEnterEmailModal={setEnterEmailModal} form={form} fullName={fullName} setFullName={setFullName} callClientApi={callClientApi} />
        </Modal>
      )}
      {sourceType === "MANUAL_ADD_CLIENTS" ? <ManualAddSeller allClientDetailsLoading={allClientDetailsLoading} currentUrlId={currentUrlId} contractAuthKey={contractAuthKey} sourceType={sourceType} source={"CLIENTS"} clientType={clientType} clientsArray={clientsArray} setClientsArray={setClientsArray} handleCorpAdd={handleCorpAdd} trustName={trustName} setTrustName={setTrustName} setCurrentlySelectedData={setCurrentlySelectedData} labelType={labelType} /> : null}

      {
        <>
          {sourceType === "NORMAL" && (
            <div className={styles.personheading}>
              <div
                onClick={
                  onlySignersAllowedToEdit
                    ? undefined
                    : () => {
                        setShowClientListModal(true);
                        setCurrentlySelectedData({});
                      }
                }
                style={{ cursor: "pointer", display: "flex", alignItems: "center" }}
              >
                Add Contact
                {/* <SearchOutlined style={{ marginLeft: "10px" }} /> */}
                <PlusCircleFilled style={{ marginLeft: "10px", color: "rgb(8, 81, 145)" }} />
              </div>
              {checkIfAddMeBtnVisible() && (
                <div
                  onClick={() => handleAddMe()}
                  style={{
                    backgroundColor: "#1890ff",
                    color: "white",
                    fontSize: "14px",
                    padding: "0px 10px",
                    border: "none",
                    borderRadius: "4px",
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    textAlign: "center",
                  }}
                >
                  Add Me
                </div>
              )}
            </div>
          )}
          <Form layout="vertical" initialValues={{}} autoComplete="off">
            {sourceType === "NORMAL" ? (
              <>
                {allClientDetailsLoading ? <div style={{display: 'flex', minHeight: "10vh", alignItems: 'center', justifyContent: 'center'}}><Spin /></div> : 
                nonCorpClients?.length > 0 ? (
                  <Form.Item>
                    <Row>
                      <Col className={styles.selectedRowsOuterDivParent}>
                        <div className={styles.selectedRowsOuterDiv}>
                          <List
                            dataSource={clientsArray.filter((ele) => !ele.isCorp)}
                            renderItem={(item) => {
                              const intials = generateInitialsFromObj(item);
                              return (
                                <List.Item
                                  key={item?.personId}
                                  style={{
                                    margin: isMobile ? "-5px 5px" : "5px 5px",
                                    width: "90%",
                                  }}
                                >
                                  <List.Item.Meta
                                    avatar={
                                      intials ? (
                                        <Avatar onClick={() => handleAvatarClick({ item })} size={isMobile ? 30 : 45} style={{ background: "#085191", fontSize: isMobile ? "12px" : "18px",  }}>
                                          {intials}
                                        </Avatar>
                                      ) : (
                                        <Avatar onClick={() => handleAvatarClick({ item })} size={isMobile ? 30 : 45} icon={<UserOutlined />} style={{ background: "#085191", }} />
                                      )
                                    }
                                    title={
                                      <div className={styles.clientNameFlex}>
                                        <span className={styles.clientName}> {item?.fullName || ""}</span>
                                        {(item?.personId?.email || item?.email) ? (
                                          <Typography.Text className={styles.clientEmail} copyable>
                                            {item?.personId?.email || item?.email}
                                          </Typography.Text>
                                        ) : (
                                            <></>
                                          // <div className={styles.addEmailBtnContainer}>
                                          //   {rootLevelEmailChanged ? (
                                          //     <Spin />
                                          //   ) : (
                                          //     <button onClick={() => handleAvatarClick({ item, source: "ROOT_LEVEL_ADD_EMAIL" })} className={styles.addEmailButton}>
                                          //       Add Email
                                          //     </button>
                                          //   )}
                                          // </div>
                                        )}
                                      </div>
                                    }
                                  />
                                  <div style={{ display: "flex", gap: "10px", alignItems: "center", justifyContent: "space-between" }}>
                                    <span onClick={() => handleAvatarClick({ item })}>
                                      <EditOutlined style={{ cursor: "pointer", color: "#359eff" }} />
                                    </span>
                                    {onlySignersAllowedToEdit ? null : (
                                      <span onClick={() => handleDelete(item, "CLIENT")} style={{ cursor: "pointer" }}>
                                        <DeleteTwoTone style={{ fontSize: "medium" }} />
                                      </span>
                                    )}
                                  </div>
                                </List.Item>
                              );
                            }}
                          />
                        </div>
                      </Col>
                    </Row>
                  </Form.Item>
                ) : (
                  <Card
                    bordered
                    style={{
                      display: "flex", // Enables Flexbox
                      flexDirection: "column", // Stack items vertically
                      justifyContent: "center",
                      alignItems: "center",
                      textAlign: "center",
                      background: "#e6f7ff",
                      borderRadius: "8px",
                      height: "150px",
                      marginTop: "10px",
                      cursor: "pointer",
                    }}
                    onClick={
                      onlySignersAllowedToEdit
                        ? undefined
                        : (event) => {
                            setShowClientListModal(true);
                            // setCurrentlySelectedData(event);
                          }
                    }
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <PlusOutlined style={{ fontSize: "24px", color: "#1890ff" }} />
                      <div style={{ marginTop: "8px", color: "#1890ff", fontSize: "18px" }}>Add Contact</div>
                    </div>
                  </Card>
                )}
              </>
            ) : null}
            <div className={styles.corpheading} style={{ marginTop: "10px" }}>
              <text>Corporation/Trust/Other</text>
            </div>
            <div style={{ display: "flex", flexDirection: "column", whiteSpace: "nowrap", alignItems: "stretch" }}>
              {onlySignersAllowedToEdit
                ? null
                : (addCorps || corpClients?.length > 0) && (
                    <Form.Item name="trustee">
                      <div style={{ display: "flex", gap: "10px", marginTop: "10px", marginBottom: "-25px" }}>
                        <Input data-no-auto-save data-not-autofill-values allowClear placeholder="Enter Corporation/Trust Name" onKeyPress={handleKeyPress} name="trustee" value={trustName && trustName.length > 0 ? trustName : ""} onChange={(e) => setTrustName(e.target.value)} />

                        <Button type="primary" onClick={handleCorpAdd} disabled={!trustName}>
                          Add
                        </Button>
                      </div>
                    </Form.Item>
                  )}
              <div style={{ width: "100%", overflow: "hidden" }}>
                <div style={{ background: "white" }}>
                  {allClientDetailsLoading ? <div style={{display: 'flex', minHeight: "10vh", alignItems: 'center', justifyContent: 'center'}}><Spin /></div> : 
                  corpClients?.length > 0 ? (
                    clientsArray
                      ?.filter((ele) => ele.isCorp)
                      .map((ele, ind) => (
                        <div
                          key={ind}
                          style={{
                            marginTop: "10px",
                            borderBottom: "1px solid #f0f0f0",
                          }}
                        >
                          {/* Corporation Header */}
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                              marginTop: "10px",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                gap: "20px",
                                width: "100%",
                              }}
                            >
                              <span
                                style={{
                                  fontSize: "18px",
                                  textTransform: "capitalize",
                                  maxWidth: isMobile ? "160px" : "auto",
                                  minWidth: isMobile ? "160px" : "70%",
                                  wordBreak: "break-word", // Ensures long words wrap to the next line
                                  whiteSpace: "normal", // Allows wrapping of text
                                }}
                              >
                                {ele.fullName || ""}
                              </span>
                              <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                                <div>
                                  <EditOutlined style={{ cursor: "pointer", color: "#359eff" }} onClick={() => handleAvatarClick({ item: ele })} />
                                </div>
                                <div>
                                  <Tooltip title="Add Signers">
                                    <PlusCircleFilled
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        handleAddSigners(ele, sourceType);
                                      }}
                                      style={{
                                        fontSize: "20px",
                                        fill: "#085191",
                                        color: "#085191",
                                        marginTop: "6px",
                                      }}
                                    />
                                  </Tooltip>
                                </div>
                                {onlySignersAllowedToEdit ? null : (
                                  <div
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handleDelete(ele, "CORP");
                                    }}
                                  >
                                    <Tooltip title="Delete Corporation/Trust">
                                      <DeleteTwoTone
                                        style={{
                                          fontSize: "medium",
                                          marginTop: "8px",
                                          cursor: "pointer",
                                        }}
                                      />
                                    </Tooltip>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>

                          {/* Signers List */}
                          {(ele.signers || []).length > 0 ? (
                            <List
                              dataSource={ele.signers}
                              renderItem={(item) => {
                                const initials = generateInitialsFromObj(item);
                                return <EachCorpSigner key={item?._id} handleAvatarClick={handleAvatarClick} item={item} ele={ele} initials={initials} isMobile={isMobile} clientType={clientType} currentUrlId={currentUrlId} handleDelete={handleDelete} handleDataChange={handleDataChange} rootLevelEmailChanged={rootLevelEmailChanged} />;
                              }}
                            />
                          ) : (
                            <EmptyData />
                          )}
                        </div>
                      ))
                  ) : (
                    <Card
                      bordered
                      style={{
                        display: "flex", // Enables Flexbox
                        flexDirection: "column", // Stack items vertically
                        justifyContent: "center", // Centers content vertically
                        alignItems: "center", // Centers content horizontally
                        textAlign: "center",
                        background: "#e6f7ff",
                        borderRadius: "8px",
                        height: "140px",
                        marginTop: "10px",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        setAddCorp(!addCorps);
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <PlusOutlined style={{ fontSize: "24px", color: "#1890ff" }} />
                        <div style={{ marginTop: "8px", color: "#1890ff", fontSize: "18px" }}>Add Corporation/Trust/Other</div>
                      </div>
                    </Card>
                  )}
                </div>
              </div>
            </div>
          </Form>
        </>
      }
      {enterEmailModal?.visible && <AddEmail enterEmailModal={enterEmailModal} setEnterEmailModal={setEnterEmailModal} form={form} handleAddEmail={handleAddEmail} clickedDataEmail={clientDetailModal?.data} selectedData={{ offerId: rootDocData?.offerId }} userAuthKey={contractAuthKey} source={callClientApi ? "AVATAR_DATA" : "AVATAR_PAGE_REFRESH"} offerId={rootDocData?.offerId} rootDocData={rootDocData} />}
    </>
  );
};

function ClientDetailSection({ clientDetailModal, isMobile, clientType, contractAuthKey, currentUrlId, clientsArray, enterEmailModal, setEnterEmailModal, fullName, setFullName, callClientApi }) {
  const dispatch = useDispatch();
  // const [enterEmailModal, setEnterEmailModal] = useState({
  //   visible: false,
  //   data: {},
  //   inValid: false,
  // });
  // const name = clientDetailModal?.data?.personId?.fullName ? clientDetailModal?.data?.personId?.fullName : clientDetailModal?.data?.fullName
  // const [fullName, setFullName] = useState(name);
  // const callClientApi = clientDetailModal?.data?.personId ? true : false;
  const { getClientDetail, getClientError, getClientLoading, renderClient, autoSaveContractStaus } = useSelector((state) => state.contractStore);
  const { rootDocData } = useSelector((state) => state.createOffer);
  const { addEmailLoading } = useSelector((state) => state.rtdTransactionLane);
  let unmounted = {
    value: false,
  };
  let sourceAxios = axios.CancelToken.source();
  useEffect(() => {
    if (callClientApi) {
      dispatch(contractStoreHandle.getClientDetailsFun({ unmounted, sourceAxios, personId: (clientDetailModal?.data?.personId?._id || clientDetailModal?.data?.personId), accessToken: contractAuthKey }));
    }

    return () => {
      unmounted.value = true;
      sourceAxios.cancel("Cancelling in cleanup");
    };
  }, [renderClient]);
  const [form] = Form.useForm();

  const handleChange = (e) => {
    setFullName(e.target.value);
  };

  // const handleAddEmail = (values, check) => {
  //   let data = {
  //     addToProperty: false,
  //     offerId: rootDocData?.offerId,
  //     ...(((clientType === "Buyers") && rootDocData?.openFor === "BUYER_AGENT"))
  //     ? {
  //         buyerDetail: {
  //           fullName,
  //           ...(clientDetailModal?.data?.personId ? {
  //             personId: clientDetailModal?.data?.personId
  //           } : {
  //             key: clientDetailModal?.data?.key ? clientDetailModal?.data?.key : clientDetailModal?.data?._id,
  //             isCorp: clientDetailModal?.data?.isCorp,
  //             corpKey: clientDetailModal?.data?.corpKey
  //           }),
  //           ...(values?.email?.length > 0 ? { email: values?.email?.toLowerCase() } : {}),
  //         },
  //       }
  //     : {
  //         sellerDetail: {
  //           fullName,
  //           ...(clientDetailModal?.data?.personId ? {
  //             personId: clientDetailModal?.data?.personId
  //           } : {
  //             key: clientDetailModal?.data?.key ? clientDetailModal?.data?.key : clientDetailModal?.data?._id,
  //             isCorp: clientDetailModal?.data?.isCorp,
  //             corpKey: clientDetailModal?.data?.corpKey
  //           }),
  //           ...(values?.email?.length > 0 ? { email: values?.email?.toLowerCase() } : {}),
  //         },
  //       },
  //     ...(values?._id ? { selectedId: values?._id } : {}),
  //     ...(check ? { newClient: true } : {}),
  //   }
  //   setEnterEmailModal({ ...enterEmailModal, visible: false })
  //   dispatch(transactionLaneDataHandle.addEmailFun({ data, userAuthKey: contractAuthKey, source: callClientApi ? "AVATAR_DATA" : "AVATAR_PAGE_REFRESH", setEnterEmailModal, enterEmailModal, form }));
  // }

  const handleSave = () => {
    confirm({
      // title: `Apply this change to this just this contract or every unsigned contract going forward?`,
      title: `Apply this change to this this contract?`,
      okText: "Current Contract",
      // cancelText: "All Contracts",
      cancelText: "Cancel",
      icon: <ExclamationCircleOutlined />,
      onOk() {
        let clientData = clientsArray?.map((element) => {
          if (element?.isCorp) {
            if ((element.key && element.key === clientDetailModal?.data?.key) || (element.personId && element.personId === clientDetailModal?.data?.personId)) {
              element.fullName = fullName;
            }
            element.signers = element?.signers?.map((signer) => {
              if ((signer.key && signer.key === clientDetailModal?.data?.key) || (signer.personId && signer.personId === clientDetailModal?.data?.personId)) {
                signer.fullName = fullName;
              }
              return signer;
            });
            return element;
          } else {
            if ((element.key && element.key === clientDetailModal?.data?.key) || (element.personId && element.personId === clientDetailModal?.data?.personId)) {
              element.fullName = fullName;
            }
            return element;
          }
        });
        dispatch(contractStoreHandle.autoSaveContract({ currentUrlId, contractAuthKey, valueObj: { [clientType]: clientData } }));
        let localData = JSON.parse(localStorage.getItem(currentUrlId)) || {};
        localData[clientType] = clientData;
        localStorage.setItem(currentUrlId, JSON.stringify(localData));
      },
      onCancel() {},
    });
  };

  return (
    <div style={{ minHeight: "150px", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
      {(callClientApi || addEmailLoading) && (getClientLoading || addEmailLoading) ? (
        <Spin />
      ) : getClientError ? (
        "...something went wrong"
      ) : (
        <div style={{ display: "grid", gap: "20%", fontSize: isMobile ? 14 : 16 }}>
          {/* {enterEmailModal?.visible && <AddEmail enterEmailModal={enterEmailModal} setEnterEmailModal={setEnterEmailModal} form={form} handleAddEmail={handleAddEmail} clickedDataEmail={clientDetailModal?.data} selectedData={{offerId: rootDocData?.offerId}} userAuthKey={contractAuthKey} source={callClientApi ? "AVATAR_DATA" : "AVATAR_PAGE_REFRESH"} offerId={rootDocData?.offerId} rootDocData={rootDocData} />} */}
          <div style={{ display: "flex", gap: "10px", color: "#134f8f", fontWeight: 600 }}>
            <div>Name:</div>
            {autoSaveContractStaus ? (
              <Spin />
            ) : (
              <div style={{ display: "flex", gap: 10 }}>
                <Input value={fullName} onChange={handleChange} size={isMobile ? "small" : "middle"} />
                <Button type="primary" disabled={!fullName?.trim()} onClick={handleSave} size={isMobile ? "small" : "middle"}>
                  Done
                </Button>
              </div>
            )}
          </div>
          {(!clientDetailModal?.data?.isCorp || clientDetailModal?.data?.isSigner) && (
            <div style={{ display: "flex", gap: "10px", color: "#134f8f", fontWeight: 600 }}>
              <div>Email:</div>
              <div>
                {getClientDetail?.email && callClientApi ? (
                  <Typography.Text copyable style={{ color: "#0707ff" }}>
                    {getClientDetail?.email || ""}
                  </Typography.Text>
                    ) : (
                        <>
                        </>
                  // <button
                  //   onClick={() => {
                  //     setEnterEmailModal({ ...enterEmailModal, visible: true });
                  //   }}
                  //   style={{ backgroundColor: "#1890ff", color: "white", border: "none", borderRadius: "2px", cursor: "pointer" }}
                  // >
                  //   Add Email
                  // </button>
                )}
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default EditCorpOrClient;
